import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { getColumnStyle } from 'utils/getColumnStyle';

const defaultStyle264 = getColumnStyle(264);

const BaseDatagridStyled = styled(DatagridConfigurableWithStickyActions)({
  '& .column-adjustmentType': defaultStyle264,
  '& .column-rejectReason': defaultStyle264,
  '& .column-impactToBalance': { minWidth: '230px' },
  '& .column-amount': { textAlign: 'right' },
});

export const DatagridStyled = withDatagridStickyStyles(BaseDatagridStyled);
